import { Paths } from "./routePaths";

export const getLogoutRedirectPath = ({ pathname = window?.location?.pathname || "", userRole } = {}) => {
  const currentPath = String(pathname || "").toLowerCase();
  const isAdminArea = currentPath.startsWith("/admin");

  if (userRole === "entrepreneur_admin" || isAdminArea) {
    return Paths.EntrepreneurAdminLogin;
  }

  return Paths.Home;
};
